import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_get_latest_order_by_projectService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { project_ids?: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Orders?: { PreferredWarehouseId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedWarehouseId?: number } }[] }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_get_latest_order_by_project/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { project_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Orders?: { PreferredWarehouseId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedWarehouseId?: number } }[] }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_get_latest_order_by_project/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { project_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Orders?: { PreferredWarehouseId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedWarehouseId?: number } }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_get_latest_order_by_project/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

